import { render, staticRenderFns } from "./sponsor-site-info.tests.vue?vue&type=template&id=1d5a7a1e&scoped=true"
import script from "./sponsor-site-info.tests.vue?vue&type=script&lang=ts"
export * from "./sponsor-site-info.tests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5a7a1e",
  null
  
)

export default component.exports